const fakeLocalStorage = { };

const _getLocalStorage = () => {
  try {
    // Merely accessing window.localStorage throws security exception in newer version of test runner.
    // However, this does not apply to jest tests, which uses JSDom. This can likely be simplified to simply accessing
    // localStorage, but I'm leaving this be for now.
    return window.localStorage || fakeLocalStorage;
  } catch (ignored) {
    return fakeLocalStorage;
  }
};

/** Get a variable from local storage. */
export const getLocalStorageValue = (variableName) => {
  return _getLocalStorage()[variableName];
};

/** Get a variable from local storage that was stored as a JSON string, returning the parsed value. */
export const getParsedLocalStorageJson = (variableName) => {
  const value = _getLocalStorage()[variableName];
  return value ? JSON.parse(value) : undefined;
};

/** Get a flag variable from local storage, returning true/false. */
export const getLocalStorageFlag = (flagname) => {
  const value = _getLocalStorage()[flagname];

  // Converting to string for comparison handles the case
  // where setting flag to false in console window will convert the value to "false"
  return String(value) === 'true';
};

export const unitTestPrivate = {
  _getLocalStorage
};
